import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';

import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { HostListener } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.scss'],
})
export class ShowcaseComponent implements OnInit, OnDestroy {
  moviesListCategory: any;
  objectKeys = Object.keys;
  searchIcon: any = 'assets/images/cinejoy/Search.png';
  leftArrow: any = 'assets/images/cinejoy/arrow-left.png';
  filterMovieList: any;
  catSub: any;
  orignalFilterMovieList: any[] = [];
  smoothScroll: (elem: any, offset?: number) => Promise<unknown>;
  movieDisplayed: any;
  BackgroundImage: any;
  DazzlermovieList: any;
  GoodTimesmovieList: any;
  IlluminationmovieList: any;
  InspirationmovieList: any;
  LaughsmovieList: any;
  LovemovieList: any;
  ThrillsmovieList: any;
  MindBendersmovieList: any;
  AnimationmovieList: any;
  ComedymovieList: any;
  CrimemovieList: any;
  DocumentarymovieList: any;
  DramamovieList: any;
  FantasymovieList: any;
  RomanticComedymovieList: any;
  HorrormovieList: any;
  SciFimovieList: any;
  ThrillermovieList: any;
  loadFalse: boolean = false;

  constructor(
    public router: Router,
    private showcaseService: ShowcaseService,
    private scroller: ViewportScroller,
    private _location: Location,
  ) { }
  id: any;
  Isshow: boolean = false;
  moviesArray: any[] = [];
  searchBox: any = '';
  movieList: any = [];
  shorts: any = [];
  feature: any = [];
  categorySelected: boolean = false;
  FeaturemovieList: any = [];
  ShortsmovieList: any = [];
  moviesCollection: any = [];
  categories: any = [];
  subCategories: any = [];
  subct: any;
  cat: any;
  ThrillersubCategories: any = [];
  FeaturesubCategories: any = [];
  ShortssubCategories: any = [];
  sub: any = [];
  features: any = [];
  AllmovieList: any = [];
  name: any;
  secondaryNav = false;
  i: any;
  filtermovieList: any[];
  featureSub: any = 'Features';
  catGen: any;
  genre: any;
  btnVal = 'Feature >';
  headingVal = 'Showcase';
  headingVal1 = 'Shorts >';
  btnVal1 = 'Shorts >';
  activeCategory: string;
  public isCollapsed: boolean = false;
  selectedMovieId: string;
  ngOnInit(): void {
    this.activeCategory = this.router.url.split('/')[2];
    console.log(this.router.url.split('/'),'rasb ')
    if (
      this.router.url.split('/')[3] == 'emotion' ||
      this.router.url.split('/')[3] == 'genre' ||
      this.router.url.split('/')[3] == 'features' ||
      this.router.url.split('/')[3] == 'shorts' ||
      this.router.url.includes('/archive')
    ) {
      this.categorySelected = true;
      if (sessionStorage.getItem('movieNavigation') !== null) {
        let item = JSON.parse(sessionStorage.getItem('movieNavigation'));
        this.cat = item.category;
        this.subct = item.subCategories;
        if (sessionStorage.getItem('type')) {
          this.featureSub = sessionStorage.getItem('type')
        } else {
          this.featureSub = 'Features';
          sessionStorage.setItem('type', this.featureSub)
        }
        this.subct = item.subCategories
        this.getMoviesByCategory(item.category, item.subCategories);
      } else {
        let obj;
        if (sessionStorage.getItem('type')) {
          this.featureSub = sessionStorage.getItem('type')
        } else {
          this.featureSub = 'Features';
          sessionStorage.setItem('type', this.featureSub)
        }

        if (this.router.url.split('/')[3] === 'shorts' || this.router.url.split('/')[4] === 'shorts') {
          this.subct = 'nil';
          this.cat = 'Shorts'
          obj = {
            subCategories: 'nil',
            category: 'Shorts',
            type: 'Shorts',
          };
        }
        if (this.router.url.split('/')[3] === 'features' || this.router.url.split('/')[4] === 'features') {
          this.subct = 'nil'
          this.cat = 'Features'
          obj = {
            subCategories: 'nil',
            category: 'Features',
            type: 'Features',
          };
        }
        if (this.router.url.split('/')[3] === 'emotion' || this.router.url.split('/')[4] === 'emotion') {
          this.subct = 'Dazzlers'
          this.cat = 'emotion'
          obj = {
            subCategories: 'Dazzlers',
            category: 'emotion',
            type: this.featureSub,
          };
          this.selectedCategory(this.subct, this.cat)
        }
        if (this.router.url.split('/')[3] === 'genre' || this.router.url.split('/')[4] === 'genre') {
          this.subct = 'Comedy'
          this.cat = 'genre'
          obj = {
            subCategories: 'Comedy',
            category: 'genre',
            type: this.featureSub,
          };
          this.selectedCategory(this.subct, this.cat)
        }
        sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
        this.showcaseService.categoryObs$.next(JSON.stringify(obj));
        //  this.getMoviesByCategory(this.cat, this.subct);
      }
      if (this.router.url.split('/')[3] === 'shorts' || this.router.url.split('/')[4] === 'shorts') {
        this.featureSub = 'Shorts'
      }
      if (this.router.url.split('/')[3] === 'features' || this.router.url.split('/')[4] === 'features') {
        this.featureSub = 'Features'
      }
      this.getMoviesByCategory(this.cat, this.subct);
      // this.getShowcaseList();
    }
    if (this.router.url == '/cinejoy/showcase/archive') {
      this.categorySelected = false;
    }
    this.getShowcases();

    this.getShowcaseList();
    this.showcaseService.scrollObs$.subscribe((res) => {
      this.selectedMovieId = res.replace('movies', '');
    });

    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    const item = toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
    this.loadFalse = item;

    this.getShortsMovieList()
    this.getFeaturesList()

  }

  getShowcaseList() {
    this.showcaseService.getShowcaseList().subscribe((res) => {
      this.AllmovieList = res;
      this.moviesListCategory = this.AllmovieList.flatMap(
        (ele) => ele.emotions
      );
      // this.moviesCollection = new Set(this.moviesListCategory);
    });
    this.showcaseService.scrollObs$.subscribe((res) => {
      this.selectedMovieId = res.replace('movies', '');
    });
  }
  showcaseItems: any;
  getShowcases() {
    this.showcaseService.getShowcases().subscribe((res) => {
      this.showcaseItems = res;
      this.movieList = res.moviesArray;
      this.categories = res.categories;
      this.subCategories = res.subCategories;
      this.getItemBasedOnCategoryForMobileView()
      //this.movieDisplayed = this.movieList[0];
    });
  }
  backClicked() {
    this._location.back();
  }

  //button click function
  changeText() {
    this.btnVal = '';
    this.btnVal1 = '';
    this.headingVal = 'Features';
    this.display = !this.display;
    this.Isshow = true;
  }
  changeText1() {
    this.headingVal = 'Shorts';
    this.display = !this.display;
    this.Isshow = true;
  }

  display: boolean;
  display1: boolean;
  show: boolean;
  toggle() {
    this.display = !this.display;
  }
  toggle1() {
    this.display1 = !this.display1;
  }
  @ViewChild('scroll') scroll: ElementRef;
  scrollTop() {
    this.scroll.nativeElement.scrollTop = 0;
  }
  search(event): void {
    if (event.target.value.length > 2) {
      this.filterMovieList = this.filterMovieList.filter((movie) =>
        movie.name.toLowerCase().includes(event.target.value)
      );
    } else {
      this.subcatClick();
    }
  }
  subcatClick() {
    if (this.router.url === '/cinejoy/showcase/genre' || this.router.url === '/cinejoy/showcase/emotion') {
      this.showcaseService
        .getMoviesByCategories(this.cat, this.featureSub, this.subct)
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            let obj = {
              subCategories: this.subct,
              category: this.cat,
              type: this.featureSub,
            };
            this.showcaseService.categoryObs$.next(JSON.stringify(obj));
            this.showcaseService.scrollObs$.next(
              `movies${res.moviesArray[0].id}`
            );
            this.selectedMovieId = res.moviesArray[0].id;
            sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
            if (this.router.url.includes('/archive')) {
              this.router.navigateByUrl(`/cinejoy/showcase/archive/${obj.category}`);
            } else {
              this.router.navigateByUrl(`/cinejoy/showcase/${obj.category}`);
            }
          },
          (err) => { }
        );
    } else if (this.router.url === '/cinejoy/showcase/archive/genre' || this.router.url === '/cinejoy/showcase/archive/emotion') {
      this.showcaseService
        .getShowcaseArchiveListOnCategory(this.cat, this.featureSub, this.subct)
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            let obj = {
              subCategories: this.subct,
              category: this.cat,
              type: this.featureSub,
            };
            this.showcaseService.categoryObs$.next(JSON.stringify(obj));
            this.showcaseService.scrollObs$.next(
              `movies${res.moviesArray[0].id}`
            );
            this.selectedMovieId = res.moviesArray[0].id;
            sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
            if (this.router.url.includes('/archive')) {
              this.router.navigateByUrl(`/cinejoy/showcase/archive/${obj.category}`);
            } else {
              this.router.navigateByUrl(`/cinejoy/showcase/${obj.category}`);
            }
          },
          (err) => { }
        );
    }else if(this.router.url === '/cinejoy/showcase/features' || this.router.url === '/cinejoy/showcase/archive/features'){
      this.selectedCategory('nil', 'features')
    }else if(this.router.url === '/cinejoy/showcase/shorts' || this.router.url === '/cinejoy/showcase/archive/shorts'){
      this.selectedCategory('nil', 'shorts')
    }

  }
  featureClick() {
    if (this.featureSub === 'Feature') {
      this.filterMovieList = this.AllmovieList.filter(
        (movie) => movie.emotions.includes(this.subct) && movie.isFeature
      );
      this.orignalFilterMovieList = this.filterMovieList;
    } else {
      this.filterMovieList = this.AllmovieList.filter(
        (movie) => movie.emotions.includes(this.subct) && movie.isShorts
      );
      this.orignalFilterMovieList = this.filterMovieList;
    }
  }
  selectedCategory(subcat, category) {
    this.subct = subcat;
    this.cat = category;
    this.categorySelected = true;
    this.featureSub = this.featureSub;
    if (subcat == 'nil' && category == 'features') {
      this.featureSub = 'Features';
    } else if (subcat == 'nil' && category == 'shorts') {
      this.featureSub = 'Shorts';
    }
    if (this.router.url.includes('/archive')) {
      this.showcaseService
        .getShowcaseArchiveListOnCategory(category, this.featureSub, subcat)
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }
            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    } else {
      this.showcaseService
        .getMoviesByCategories(category, this.featureSub, subcat)
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }
            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    }

    let obj = {
      subCategories: this.subct,
      category: this.cat,
      type: this.featureSub,
    };
    sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
    this.showcaseService.categoryObs$.next(JSON.stringify(obj));
    //this.router.navigateByUrl(`/showcase/${category}`);
    if (this.router.url.includes('/archive')) {
      this.router.navigateByUrl(`/cinejoy/showcase/archive/${category}`);
    } else {
      this.router.navigateByUrl(`/cinejoy/showcase/${category}`);
    }
  }

  selectedGenre(subcat, category) {
    this.genre = subcat;
    this.catGen = category;
    this.categorySelected = true;
    this.filterMovieList = this.AllmovieList.filter(
      (movie) => movie.emotions.includes(this.subct) && movie.isFeature
    );
    this.orignalFilterMovieList = this.filterMovieList;
  }

  toggleNav(flag: boolean): void {
    this.secondaryNav = flag;
    this.show = !this.show;
    this.searchBox = '';
    this.subcatClick();
  }

  isSecondarySideNavOpen: boolean;
  updateSecondarySideNavStatus($event: any): void {
    this.isSecondarySideNavOpen = $event;
    this.categorySelected = false;
  }

  prepareRoute(outlet: RouterOutlet): any {
    return (
      outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation
    );
  }

  setMenuNavDefault() {
    this.categorySelected = false;
    this.display = false;
    if (this.router.url.includes('/archive')) {
      this.router.navigateByUrl('/cinejoy/showcase/archive');
    } else {
      this.router.navigateByUrl('/cinejoy/showcase');
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.categorySelected = false;
    this.display = false;
    this.featureSub = 'Features';
  }

  findMovieById(event) {
    let value = `movies${event}`;
    this.showcaseService.scrollObs$.next(value);
    this.selectedMovieId = event;
    this.movieDisplayed = event;
  }

  getMoviesByCategory(category, subcat) {
    if (this.router.url.includes('/archive')) {
      this.showcaseService
        .getShowcaseArchiveListOnCategory(category, this.featureSub, subcat)
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }

            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    } else {
      this.showcaseService
        .getMoviesByCategories(category, this.featureSub, subcat)
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }

            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }

  navigateShowcaseArchive(event) {
    this.categorySelected = false;
  }

  onChangeOfCategory() {
    if (this.router.url.includes('/cinejoy/showcase/emotion') || this.router.url.includes('/cinejoy/showcase/genre')) {
      sessionStorage.setItem('type', this.featureSub)
      return this.selectedCategory(this.subct, this.cat);
    }
    if (this.router.url.includes('/cinejoy/showcase/archive/emotion') || this.router.url.includes('/cinejoy/showcase/archive/genre')) {
      sessionStorage.setItem('type', this.featureSub)
      return this.selectedCategory(this.subct, this.cat);
    }
    if (this.featureSub == 'Features') {
      this.cat = 'Features';
    } else if (this.featureSub == 'Shorts') {
      this.cat = 'Shorts';
    }
    sessionStorage.setItem('type', this.featureSub)
    if (this.router.url.includes('/archive')) {
      this.showcaseService
        .getShowcaseArchiveListOnCategory(this.cat, this.featureSub, 'nil')
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }
            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    } else {
      this.showcaseService
        .getMoviesByCategories(this.cat, this.featureSub, 'nil')
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }
            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    }

    let obj = {
      subCategories: this.subct,
      category: this.cat,
      type: this.featureSub,
    };
    sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
    this.showcaseService.categoryObs$.next(JSON.stringify(obj));
    if (this.featureSub == 'Features') {
      if(this.router.url.includes('/cinejoy/showcase/archive')){
        this.router.navigateByUrl('/cinejoy/showcase/archive/features')
      }else{
        this.router.navigateByUrl('/cinejoy/showcase/features')
      }

    } else if (this.featureSub == 'Shorts') {

      if(this.router.url.includes('/cinejoy/showcase/archive')){
        this.router.navigateByUrl('/cinejoy/showcase/archive/shorts')
      }else{
        this.router.navigateByUrl('/cinejoy/showcase/shorts')
      }
    }

  }
  newArray: any = [];
  searchThis(data: any) {
    this.newArray = this.AllmovieList;
    if (data) {
      this.AllmovieList = this.newArray.filter((movie: any) => {
        let arrayelement = (movie.name.trim().toLowerCase());
        return arrayelement.includes(data.toLowerCase());
      });
      this.newArray;
    }
    else {
      this.getShowcaseList();
      this.newArray;
    }


  }

  refreshPage() {
    this.newArray = [];
    this.ngOnInit()
  }

  hideCategory() {
    this.categorySelected = false;
  }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    sessionStorage.clear()
  }

  getmovieName(moviename) {
    let name = moviename.replace(/ /g, '-');
    return name;
  }

  ngOnDestroy() {
    // screen.orientation.unlock();
  }
  showcaseMobileMovieList: any = [];
  getItemBasedOnCategoryForMobileView() {
    let item = []
    let subcategory = ['features', 'shorts']
    this.showcaseItems.categories.forEach(element => {
      item[element.name] = {}
      element.subCategories.map((res) => {
        subcategory.map((subcategory) => {
          if (this.router.url.includes('/archive')) {
            this.showcaseService
              .getShowcaseArchiveListOnCategory(element.name, subcategory, res.name)
              .subscribe(
                (archivelist) => {
                  if (subcategory == 'shorts') {
                    archivelist.moviesArray.forEach(movie => {
                      item[element.name][res.name].moviesArray.push(movie);
                    });

                  } else {
                    item[element.name][res.name] = archivelist;
                  }
                },
                (err) => {
                  console.log(err);
                }
              );
          } else {
            this.showcaseService.getMoviesByCategories(element.name, subcategory, res.name)
              .subscribe(
                (list) => {
                  if (subcategory == 'shorts') {
                    list.moviesArray.forEach(movie => {
                      item[element?.name][res?.name]?.moviesArray.push(movie);
                    });
                  } else {
                    item[element.name][res.name] = list;
                  }
                },
                (err) => {
                  console.log(err);
                }
              );
          }
        })

      })
    });
    this.showcaseMobileMovieList = item;
  }

  getValue(value) {
    return value.moviesArray;
  }

  getDisplayValue(value){
    if(value.moviesArray.length){
      return true
    }else{
      return false;
    }
  }
  getShortsMovieList() {
    if (this.router.url.includes('/archive')) {
      this.showcaseService
        .getShowcaseArchiveListOnCategory('Shorts', 'Shorts', 'nil').subscribe((res) => {

        })
    } else {
      this.showcaseService
        .getMoviesByCategories('Shorts', 'Shorts', 'nil').subscribe((res) => {
          this.shorts = res.moviesArray;
        })
    }
  }

  getFeaturesList() {
    if (this.router.url.includes('/archive')) {
      this.showcaseService
      .getShowcaseArchiveListOnCategory('Features', 'Features', 'nil').subscribe((res) => {
        this.feature = res.moviesArray;
      })
    } else {
      this.showcaseService
      .getMoviesByCategories('Features', 'Features', 'nil').subscribe((res) => {
        this.feature = res.moviesArray;
      })
    }
  }
}
